import { useEffect } from "react";
import { COMPANION_CONVERSATION_KEY } from "@/components/account/localProfileData";

const SESSION_KEY = "forr:companion-conversation:v3";

const read = (storage, key) => {
  try {
    return storage.getItem(key);
  } catch (_error) {
    return null;
  }
};

const write = (storage, key, value) => {
  try {
    if (value) storage.setItem(key, value);
  } catch (_error) {
    // Conversation remains available in the storage that accepted it.
  }
};

const CompanionConversationBridge = () => {
  useEffect(() => {
    const cloudCached = read(localStorage, COMPANION_CONVERSATION_KEY);
    const currentSession = read(sessionStorage, SESSION_KEY);
    if (!currentSession && cloudCached) write(sessionStorage, SESSION_KEY, cloudCached);
    if (currentSession && !cloudCached) write(localStorage, COMPANION_CONVERSATION_KEY, currentSession);

    let previous = currentSession || cloudCached || "";
    const copyCurrent = () => {
      const next = read(sessionStorage, SESSION_KEY) || "";
      if (!next || next === previous) return;
      previous = next;
      write(localStorage, COMPANION_CONVERSATION_KEY, next);
      window.dispatchEvent(new CustomEvent("adaptive-companion-conversation-saved"));
    };

    const interval = window.setInterval(copyCurrent, 2000);
    const visibility = () => {
      if (document.visibilityState === "hidden") copyCurrent();
    };
    document.addEventListener("visibilitychange", visibility);
    return () => {
      copyCurrent();
      window.clearInterval(interval);
      document.removeEventListener("visibilitychange", visibility);
    };
  }, []);

  return null;
};

export default CompanionConversationBridge;
